import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import DotSeparatedStrings from "../../../../common/components/functional/dotSeparatedStrings/DotSeparatedStrings";
import isEmpty from "../../../../common/helpers/isEmpty";

type Props = {
  title: string;
  list: ReactNode[];
};

const TalentSkillSetSection = ({ title, list }: Props) => {
  if (isEmpty(list)) return null;

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexWrap="wrap"
      flexDirection="column"
      pb="8px"
    >
      <Typography
        color="text.disabled"
        variant="header"
        sx={{
          textTransform: "uppercase",
          fontWeight: 700,
          fontSize: "10px",
          letterSpacing: "0.4px",
          lineHeight: "12px",
        }}
      >
        {title}
      </Typography>
      <DotSeparatedStrings
        dotSx={{ backgroundColor: "#000A441C" }}
        list={list}
      />
    </Box>
  );
};

export default TalentSkillSetSection;
